// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".snappy-alert[data-v-e98cc3ea]{text-align:left}.snappy-alert__close[data-v-e98cc3ea]{background:transparent}", ""]);
// Exports
module.exports = exports;
